export const messages = {
  accumulate: {
    tooltip: { id: 'admin/promotions.form.accumulations.accumulate.tooltip' },
    label: { id: 'admin/promotions.form.accumulations.accumulate' },
    helpText: {
      id: 'admin/promotions.form.accumulations.accumulate.help-text',
    },
    moreInformation: { id: 'admin/promotions.links.restrictions.accumulation' },
  },
  accumulateWithManualPrices: {
    tooltip: {
      id: 'admin/promotions.form.accumulations.accumulate-with-manual-prices.tooltip',
    },
    label: {
      id: 'admin/promotions.form.accumulations.accumulate-with-manual-prices',
    },
  },
}
